;$(function(){

	var page = {};
	page.header = {};
	page.header.callme = {};
	page.header.callme.icon = $('header.header .callme__icon');
	page.header.callme.phone = $('header.header .callme__phone-desktop a');

	var data = {};
	data.width = $(window).width();

	var action = {};
	action.onResize = () => {
		let newWidth = $(window).width();
		if (data.width > 768 && newWidth < 768) {
			data.width = newWidth;
			return;
		}
		if (data.width > 768 && newWidth > 768) {
			data.width = newWidth;
			return;
		}
		data.width = newWidth;
	}
	action.changePhones = () => {
		if (data.width < 768)
			page.header.callme.phone = $('header.header .callme__phone-mobile a');
		else
			page.header.callme.phone = $('header.header .callme__phone-desktop a');
	}

	action.changePhones();
	$(window).resize( action.onResize );

	page.header.callme.icon.click(() => window.location.href = page.header.callme.phone.attr('href'));

});